import { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { Nav } from "../components/Nav";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function AdvertiseSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let cancelled = false;

    const poll = async () => {
      if (attempts.current >= 6) { if (!cancelled) setStatus("timeout"); return; }
      attempts.current += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (cancelled) return;
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired") { setStatus("expired"); return; }
        setTimeout(poll, 2000);
      } catch {
        if (!cancelled) setTimeout(poll, 2000);
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId]);

  return (
    <div className="min-h-screen">
      <Nav />
      <div className="max-w-md mx-auto px-5 py-20 text-center" data-testid="advertise-success">
        {status === "checking" && (
          <div className="nb-card p-10">
            <Loader2 className="w-12 h-12 animate-spin mx-auto" />
            <h1 className="text-2xl font-display font-bold mt-5">Confirming your payment…</h1>
            <p className="text-[#4A4A4A] mt-2">Hang tight, this only takes a moment.</p>
          </div>
        )}
        {status === "paid" && (
          <div className="nb-card nb-shadow-lg p-10 bg-[#A8E6CF] animate-pop-in">
            <CheckCircle2 className="w-16 h-16 mx-auto" />
            <h1 className="text-3xl font-display font-bold mt-5">Campaign is live! 🎉</h1>
            <p className="text-[#0A0A0A]/80 mt-2">Your ad will now show to people in your targeted area.</p>
            <Link to="/dashboard" data-testid="success-dashboard-btn" className="nb-btn bg-white px-7 py-3.5 mt-6 inline-flex">Go to dashboard</Link>
          </div>
        )}
        {["error", "timeout", "expired"].includes(status) && (
          <div className="nb-card p-10">
            <XCircle className="w-14 h-14 mx-auto text-[#4A4A4A]" />
            <h1 className="text-2xl font-display font-bold mt-5">
              {status === "timeout" ? "Still processing" : "Payment not completed"}
            </h1>
            <p className="text-[#4A4A4A] mt-2">
              {status === "timeout" ? "Check your dashboard shortly to confirm." : "You can try launching your campaign again."}
            </p>
            <Link to="/advertise" className="nb-btn bg-[#FFB5A7] px-7 py-3.5 mt-6 inline-flex">Back to advertise</Link>
          </div>
        )}
      </div>
    </div>
  );
}
